import React, { useState } from 'react';

import { Alert, Button, Form, InputGroup, Row } from 'react-bootstrap';

import SearchIcon from '../../../assets/svg/Search';
import ModalSirenSearch from '../../../common/components/ModalSirenSearch';
import ModalSMS from '../../../common/components/ModalSMS';
import { ICompanyState } from '../reducers';

interface IProps {
  companyExists: (siren: string) => Promise<boolean>;
  getCompanyInfos: (company: string) => Promise<ICompanyState>;
  setStep: React.Dispatch<React.SetStateAction<number>>;
  handleSubmitAbout: (firstname: string, name: string, phone: string) => void;
  siren: string;
  setSiren: React.Dispatch<React.SetStateAction<string>>;
  showSmsModal: boolean;
  setShowSmsModal: React.Dispatch<React.SetStateAction<boolean>>;
  error: string;
  verifyPhoneNumber: (smsCode: string) => Promise<unknown>;
}

const AboutYourself = (props: IProps) => {
  const [showSirenModal, setShowSirenModal] = useState(false);
  const [errorCode, setErrorCode] = useState('');

  const [name, setName] = useState('');
  const [firstname, setFirstname] = useState('');
  const [phone, setPhone] = useState('+33');

  const handleSmsValidation = (event: any) => {
    setErrorCode('');
    event.preventDefault();
    const form = event.currentTarget;
    if (form.checkValidity() === true) {
      let code = '';
      Array.from(form.elements).forEach((elem: any) => {
        code += elem.value;
      });
      props
        .verifyPhoneNumber(code)
        .then(() => props.setStep(3))
        .catch(() => setErrorCode('Code non valide'));
    }
  };

  return (
    <Row className="align-items-center justify-content-center">
      <h2 className="text-center mb-0 fw-bold register-title">Vous y êtes presque</h2>
      <h3 className="text-center mb-4 fw-bold register-subtitle">Informations sur vous et votre société</h3>

      <Form className="register-form">
        <div className="mt-4 d-flex flex-row gap-2 mb-0">
          <Form.Group controlId="firstname">
            <Form.Control
              type="text"
              placeholder="Prénom"
              value={firstname}
              onChange={(e) => setFirstname(e.target.value)}
              required
            />
          </Form.Group>
          <Form.Group controlId="lastname">
            <Form.Control
              type="text"
              placeholder="Nom"
              value={name}
              onChange={(e) => setName(e.target.value)}
              required
            />
          </Form.Group>
        </div>
        <p className="mt-0 text-muted">
          Vous devez être un mandataire de la société (votre nom doit apparaître sur le KBS) pour souscrire à Dwell.
        </p>
        <Form.Group className="mb-4" controlId="phone">
          <Form.Control
            type="text"
            placeholder="Numéro de téléphone"
            value={phone}
            onChange={(e) => setPhone(e.target.value)}
            required
          />
        </Form.Group>
        <Form.Group className="mb-2" controlId="legalIdentifier">
          <InputGroup className="d-flex flex-row justify-content-start mb-3">
            <Form.Control
              className="mr-2"
              type="text"
              placeholder="Siren"
              required
              value={props.siren}
              onChange={(e) => props.setSiren(e.target.value)}
            />
            <Button variant="primary pt-0" onClick={() => setShowSirenModal(true)}>
              <SearchIcon />
            </Button>
          </InputGroup>
        </Form.Group>

        {props.error !== '' && <Alert variant="danger">{props.error}</Alert>}

        <div className="text-center">
          <Button
            className="mt-2 mb-5 btn-register w-100"
            variant="primary"
            onClick={() => props.handleSubmitAbout(firstname, name, phone)}
          >
            Suivant
          </Button>
        </div>

        <ModalSMS
          errorCode={errorCode}
          length={4}
          show={props.showSmsModal}
          setShow={props.setShowSmsModal}
          handleSubmit={handleSmsValidation}
        />
      </Form>
      <ModalSirenSearch
        show={showSirenModal}
        setShow={setShowSirenModal}
        sirenValue={props.siren}
        setSirenValue={props.setSiren}
        getCompanyInfos={props.getCompanyInfos}
      />
    </Row>
  );
};
export default AboutYourself;
